import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

@customElement('langhout-button')
export class LanghoutButton extends LitElement {
  static styles = css`
    #button:hover {
      cursor: pointer;
      background-color: var(--primary-hover-color);
    }

    #button {
      text-align: center;
      max-width: 300px;
      background-color: var(--primary-color);
      color: white;
      padding: 12px;
      border-radius: 10px;
      font-weight: 900;
    }

    :host([reverse]) #button {
      background-color: white;
      color: var(--primary-color);
      border: 1px solid var(--primary-color);
    }

    :host([reverse]) #button:hover {
      background-color: var(--background-color-hover);
    }

    :host([removeButton]) #button {
      background-color: white;
      color: red;
      border: 1px solid red;
    }

    :host([removeButton]) #button:hover {
      background-color: var(--background-color-hover);
    }
  `;

  @property({ type: String, reflect: true })
  public text = 'Button';

  @property({ type: Boolean, reflect: true })
  public reverse = false;

  @property({ type: Boolean, reflect: true })
  public removeButton = false;

  constructor() {
    super();
  }

  render() {
    return html` <div id="button">${this.text}</div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-button': LanghoutButton;
  }
}
